import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import {isEmpty, postSubmit, scrollToComponent} from '@ui-seeker/utils'
import {useAppToast} from "@ui-seeker/app";

import { isSystemBusy } from '@signals'
import { BACKEND_APIS } from '@constants'
import {reloadUserDetailsFilters, userDetailsFilters, accessOptions} from "../../@signals";


export default function useUserTableFilters() {

    const { showToast } = useAppToast()
    const data = useSignal([])
    const isLoading = useSignal(false)
    const requestSend = useSignal(false)

    const handleSubmitUsersDetailsToast = () => {
        isLoading.value = true
        showToast.promise(postSubmit(`${BACKEND_APIS.MANAGEMENT}/customer/user-context`, userDetailsFilters.value)
            .then(res => {
                data.value = res.users || []
                accessOptions.value = res.allModulesOptions || []
                isLoading.value = false
                requestSend.value = true
            })
            .catch(() => {
                isSystemBusy.value = true
            }).finally(() => scrollToComponent('users-info-table'))
        )
    }

    const handleSubmitUsersDetails = () => {
        isLoading.value = true
        postSubmit(`${BACKEND_APIS.MANAGEMENT}/customer/user-context`, userDetailsFilters.value)
            .then(res => {
                data.value = res.users || []
                accessOptions.value = res.allModulesOptions || []
                isLoading.value = false
                requestSend.value = true
            })
            .catch(() => {
                isSystemBusy.value = true
            }).finally(() => scrollToComponent('users-info-table'))
    }

    useEffect(() => {
        if (!isEmpty(userDetailsFilters.value)) batch(() => {
           handleSubmitUsersDetailsToast()
        })

        if (isEmpty(userDetailsFilters.value)) {
            data.value = []
            accessOptions.value = []
            isLoading.value = false
            requestSend.value = false
        }

    }, [JSON.stringify(userDetailsFilters.value)])

    useEffect(() => {
        if (reloadUserDetailsFilters.value) {
            handleSubmitUsersDetails()
            reloadUserDetailsFilters.value = false
        }
    }, [reloadUserDetailsFilters.value]);

    return {
        data: data.value,
        isLoading: isLoading.value,
        requestSend: requestSend.value,
    }
}